import type { AppStore } from "../store";
import { restoreWall, selectSharedWall } from "../store/slices/configurationSlice";
import { readWallLink, withWallLink } from "./wallLink";

// Safari throws once a page calls replaceState more than ~100 times in 30 s,
// which dragging the scale slider would easily do.
const WRITE_DEBOUNCE_MS = 300;

// Restores the wall from the address bar, then keeps the address bar on the
// current wall, so it can be copied or reloaded at any time. Replaces the
// history entry instead of adding one, so Back still leaves the widget.
export const syncWallLink = (store: AppStore) => {
  const shared = readWallLink(window.location.search);
  if (shared) store.dispatch(restoreWall(shared));

  let wall = selectSharedWall(store.getState());
  let timer: ReturnType<typeof setTimeout> | undefined;

  return store.subscribe(() => {
    const next = selectSharedWall(store.getState());
    if (next === wall) return;
    wall = next;
    clearTimeout(timer);
    timer = setTimeout(() => {
      try {
        window.history.replaceState(window.history.state, "", withWallLink(window.location.href, wall));
      } catch {
        // The share button builds its link from the store, so a stale address bar is harmless.
      }
    }, WRITE_DEBOUNCE_MS);
  });
};
